import { useEffect, useRef } from 'react';


/**
 * React hook that handles making an interval (`window.setInterval`), and cleans up the interval when the component
 * unmounts.
 * @param callback - The action perform on a regular interval
 * @param delayMs - The duration of the regular interval in milliseconds
 */
export const useInterval = (callback: () => void, delayMs: number): void => {
  const savedCallback = useRef<() => void>();

  // Remember the latest callback.
  useEffect(() => savedCallback.current = callback, [callback]);

  // Set up the interval.
  useEffect(
    () => {
      const id = setInterval(() => savedCallback.current?.(), delayMs);

      // Return cleanup func to React
      return () => clearInterval(id);
    },
    [delayMs],
  );
};
